import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Tender } from './tender.model';

@Injectable({
    providedIn: 'root'
})
export class TenderService {
    private apiUrl = `${environment.applicationApi}/messages/tenders`;

    constructor(private http: HttpClient) { }

    getTenders(): Observable<Tender[]> {
        console.log(`Fetching tenders from: ${this.apiUrl}`);
        return this.http.get<Tender[]>(this.apiUrl);
    }
}
